import { render, staticRenderFns } from "./ReminderModalForm.vue?vue&type=template&id=9eaecca4"
import script from "./ReminderModalForm.vue?vue&type=script&lang=js"
export * from "./ReminderModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports